<template>
	<div>
		<div style="color: #3e3e3e;margin-bottom: 15px;">企业服务>{{activeName=="one"?"企业服务":""}}</div>
		<el-tabs type="border-card" v-model="activeName">
			<el-tab-pane name="one" label="加盟信息">
				<list1></list1>
			</el-tab-pane>
			<!-- 	    <el-tab-pane name="two" label="生熟客">
		</el-tab-pane> -->
		</el-tabs>
	</div>
</template>
<script>
	import list1 from "./qiye.vue"
	// import list2 from "./storeData2.vue"
	export default {
		components: {
			list1
		},
		data() {
			return {
				activeName: "one"
			};
		},
		mounted() {
			if (this.$route.query.id == 1) {
				this.activeName = "one"
			}
			if (this.$route.query.id == 2) {
				this.activeName = "two"
			}
		},
		methods: {
			// tabs切换点击事件
			tabsSwitch(id) {
				this.tabs.forEach((v, i) =>
					i === id ? (v.isActive = true) : (v.isActive = false)
				);
			},
		},
	};
</script>
<style lang="less" scoped>
</style>